import {
  Inject,
  InjectionToken,
  ModuleWithProviders,
  NgModule,
} from '@angular/core';
import { CACHE_SERVICE } from './cache.service';
import { CacheConfig, CacheService } from './cache.interface';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { CacheInterceptor } from './cache.interceptor';
import { MergeRequestsInterceptor } from './merge-requests.interceptor';
import { VersionService } from '../version.service';

const PATH_TOKEN = new InjectionToken<string>('WS_PATH_TOKEN');
const CONFIG_TOKEN = new InjectionToken<CacheConfig>('WS_CONFIG_TOKEN');

@NgModule()
export class CacheModule {
  static register(
    path: string,
    config?: CacheConfig,
  ): ModuleWithProviders<CacheModule> {
    return {
      ngModule: CacheModule,
      providers: [
        {
          provide: PATH_TOKEN,
          useValue: path,
        },
        {
          provide: CONFIG_TOKEN,
          useValue: {
            ...(config ?? {}),
            enabled: config?.enabled == null || config.enabled,
            static: config?.static || [],
          } as CacheConfig,
        },
        {
          provide: HTTP_INTERCEPTORS,
          useExisting: MergeRequestsInterceptor,
          multi: true,
        },
        {
          provide: HTTP_INTERCEPTORS,
          useExisting: CacheInterceptor,
          multi: true,
        },
      ],
    };
  }

  constructor(
    versionSvc: VersionService,
    @Inject(PATH_TOKEN) path: string,
    @Inject(CONFIG_TOKEN) config: CacheConfig,
    @Inject(CACHE_SERVICE) cacheSvc: CacheService,
  ) {
    if (!!path && config?.enabled) {
      cacheSvc.register(path, config, versionSvc.currentVersion);
    }
  }
}
